import "./KitchenStationsList.scss"

import React from "react"
import { Link } from "react-router-dom"
import request from "request"
import usesFeatures from "usesFeatures"

import Header from "Header"
import Table from "Table"
import formatAuthCode from "formatAuthCode"

class KitchenStationsList extends React.PureComponent {
  componentDidMount() {
    this.props.fetchData("/venue_admin/kitchen_stations")
  }

  setDefault = (stationId) => {
    request.post(`venue_admin/kitchen_stations/${stationId}/set_default`).then(() => {
      this.props.fetchData("/venue_admin/kitchen_stations")
    })
  }

  // The KDS runs on its own subdomain: swap the leading `app` label of the
  // current host for `kds` so this works across dev/staging/prod without
  // hardcoding a domain.
  kdsHost = () => {
    const parts = window.location.host.split(".")
    parts[0] = "kds"
    return parts.join(".")
  }

  kdsLoginUrl = () => `${window.location.protocol}//${this.kdsHost()}/login`

  empty = () => (
    <h3 className="is-size-6 is-italic">
      No kitchen stations yet. <Link to="/kitchen-stations/new">Add one</Link> to start routing orders.
    </h3>
  )

  formatters = () => ({
    color: (s) => <span className="station-color-swatch" style={{ background: s.color }} />,
    name: (s) => <Link to={`/kitchen-stations/${s.id}/edit`}>{s.name}</Link>,
    isDefault: (s) => s.isDefault
      ? <span className="default-pill">Default</span>
      : <span className="make-default" onClick={() => this.setDefault(s.id)}>Make default</span>,
    prepTimeSeconds: (s) => `${Math.round(s.prepTimeSeconds / 60)} min`,
    categoryCount: (s) => (s.categoryIds || []).length,
    authCode: (s) => <code className="station-login-code">{formatAuthCode(s.authCode)}</code>,
    edit: (s) => <Link to={`/kitchen-stations/${s.id}/edit`}>Edit</Link>,
  })

  render() {
    if (!this.props.dataFetched) return false

    return (
      <div className="KitchenStationsList">
        <Header text="Kitchen Stations" />
        <div className="kds-login-note notification is-info is-light">
          Kitchen Display stations log in at{" "}
          <a href={this.kdsLoginUrl()} target="_blank" rel="noopener noreferrer">
            {this.kdsHost()}
          </a>{" "}
          using the login code shown for each station below.
        </div>
        <Table
          newRecordPath="/kitchen-stations/new"
          newRecordText="New Station"
          empty={this.empty()}
          showHeader
          headers={HEADERS}
          tdClasses={TD_CLASSES}
          formatters={this.formatters()}
          rows={this.props.stations}
        />
      </div>
    )
  }
}

const HEADERS = {
  color: "",
  name: "Name",
  prepTimeSeconds: "Prep target",
  categoryCount: "Categories",
  authCode: "Login code",
  isDefault: "",
  edit: "",
}

const TD_CLASSES = {
  color: "is-narrow",
  prepTimeSeconds: "is-narrow",
  categoryCount: "is-narrow",
  authCode: "is-narrow",
  isDefault: "is-narrow",
  edit: "is-narrow",
}

export default usesFeatures(["data"], KitchenStationsList)
